'use client';
import { useSyncExternalStore } from 'react';

// The registration advertises a mounted, server-gated control to Help only.
// It is not authority to mutate a credential.
const registrations = new Map<symbol, { tenantId: string; actorId: string }>();
const listeners = new Set<() => void>();
const notify = () => listeners.forEach((listener) => listener());
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
export function registerStationPinHelpCapability(tenantId: string, actorId: string) {
  const key = Symbol();
  registrations.set(key, { tenantId, actorId });
  notify();
  return () => {
    registrations.delete(key);
    notify();
  };
}
export function useStationPinHelpCapability(
  tenantId: string | null | undefined,
  actorId: string | null | undefined,
) {
  return useSyncExternalStore(
    subscribe,
    () =>
      !!tenantId &&
      !!actorId &&
      [...registrations.values()].some(
        (value) => value.tenantId === tenantId && value.actorId === actorId,
      ),
    () => false,
  );
}
